// @flow
import invariant from 'invariant';
import { configValue } from 'utils/config';

let stripeLoaded = false;
let stripeLoading = false;

const insertScript = () => {
  const publishableKey = configValue('stripe', 'publishableKey');
  invariant(publishableKey, 'Missing STRIPE_PUBLISHABLE_KEY');
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = `https://js.stripe.com/v2/`;
    script.onload = () => {
      Stripe.setPublishableKey(publishableKey);
      resolve();
    };
    invariant(document.head, 'Missing document.head');
    document.head.appendChild(script);
  });
};

export default (): Promise<void> =>
  new Promise((resolve, reject) => {
    if (stripeLoaded) return resolve();

    if (stripeLoading) {
      let retries = 0;
      (function waitForStripe() {
        if (stripeLoaded) return resolve();
        // retry for 3s
        if (retries > 100) return reject(new Error('Error loading Stripe'));
        retries += 1;
        setTimeout(waitForStripe, 30);
      })();
      return;
    }

    stripeLoading = true;

    insertScript().then(() => {
      stripeLoading = false;
      stripeLoaded = true;
      resolve();
    });
  });
